module.exports = __webpack_public_path__ + "static/media/news.3f165a24.svg";